export const MOCK_GENIE_DATA = {
  genieName: "Customer Support Assistant",
  useCase: "Help customers with product questions, troubleshooting, and support inquiries",
  language: "en",
  voiceId: "21m00Tcm4TlvDq8ikWAM", // Default Rachel voice from ElevenLabs
  voicePreference: "female friendly professional",
  conversationSettings: {
    maxDuration: 1800,
    turnTimeout: 7,
    silenceTimeout: 30,
    turnMode: "silence" as const,
  },
  systemPrompt:
    "You are a helpful customer support assistant. Be friendly, professional, and focus on solving customer problems efficiently. Always maintain a positive tone and offer clear, actionable solutions.",
  firstMessage:
    "Hi there! Thanks for reaching out. I'm here to help you with any questions or issues you might have. What can I assist you with today?",
  confidence: 0.85,
  category: "customer_service",
  description: "A friendly customer support assistant ready to help with product questions and troubleshooting.",
  supportEmails: ["support@example.com"],
  llmModel: "gemini-3-flash-preview",
  temperature: 0.6,
  maxTokens: 8000,
  voiceStability: 0.6,
  voiceSimilarity: 0.8,
  speechSpeed: 1,
  dynamicVariables: {},
  pronunciations: [],
  sendSandboxLink: false,
  sendDemoLink: false,
  sendPricingData: false,
  sendConversationReports: true,
  goal: "Resolve customer inquiries and collect feedback to improve our service",
  leadGoal:
    "Capture customer contact information including name, email, and phone number, along with their specific needs and preferred contact method",
  branding: {
    primaryColor: "#4E9CFF",
    secondaryColor: "#FF4DB8",
    customAvatarUrl: "/genie-mascots/role/support.png",
    gradientEnabled: true,
    gradientAngle: 135,
  },
};
